export interface MultiDnDWorkerInstance extends Worker {
  blobUrl: string;
}

export default class WorkerBuilder extends Worker {
  blobUrl: string;

  constructor(worker: () => void) {
    const code = worker.toString();
    const blob = new Blob([`(${code})()`]);
    const url = URL.createObjectURL(blob);
    // super() must run the real Worker constructor (TS requires it for a derived class); this still builds exactly one worker, same as the previous `return new Worker(url)` override
    super(url);
    this.blobUrl = url;
  }
}
